import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Loader from "../components/Loader";
import Cookies from "js-cookie";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function ShowUsers() {
  const getUsername = Cookies.get("username");
  const API_URL = BASE_URL + "/getusers";

  const [users, setUser] = useState([]);
  const [loading, setLoading] = useState(true);

  // Modal state
  const [selectedUser, setSelectedUser] = useState(null);

  useEffect(() => {
    axios
      .get(API_URL, {
        headers: {
          Authorization: apiKey,
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        setUser(res.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log("There was an error", error);
      });
  }, []);

  // Search table code..
  const searchTable = (e) => {
    const input = document.getElementById("search");
    const filter = input.value.toLowerCase();
    const table = document.getElementById("Table");
    const rows = table.getElementsByTagName("tr");

    for (let i = 1; i < rows.length; i++) {
      const cells = rows[i].getElementsByTagName("td");
      let match = false;

      for (let j = 0; j < cells.length; j++) {
        if (cells[j]) {
          const cellValue = cells[j].textContent || cells[j].innerText;
          if (cellValue.toLowerCase().indexOf(filter) > -1) {
            match = true;
            break;
          }
        }
      }

      rows[i].style.display = match ? "" : "none";
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>All Users</h2>
      <br />
      <div className="row">
        <div className="col-sm-2">
          <Link to="/adduser">
            <button className="btn btn-primary">Add New User</button>
          </Link>
        </div>
        <div className="col-sm-3">
          <input
            type="text"
            className="form-control"
            id="search"
            placeholder="Search here..."
            onKeyUp={searchTable}
          />
        </div>
      </div>
      <br />
      <br />
      <table className="table table-striped table-light" id="Table">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Role</th>
            <th>Email</th>
            <th>Create At</th>
            <th>Details</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {users.map((user) => {
            const createdAt = user.createdAt?._seconds
              ? new Date(user.createdAt._seconds * 1000).toLocaleString()
              : "N/A";

            // Show Role with SportCategory if user is Coach
            const roleDisplay =
              user.Role === "Coach" && user.SportCategory
                ? `${user.Role} (${user.SportCategory})`
                : user.Role;

            return (
              <tr key={user.Id}>
                <td>{user.Name}</td>
                <td>{roleDisplay}</td>
                <td>{user.Email}</td>
                <td>{createdAt}</td>
                <td>
                  <button
                    className="btn btn-dark btn-sm"
                    onClick={() => setSelectedUser(user)}
                  >
                    See Details
                  </button>
                </td>
                <td>
                  {getUsername !== user.Name && (
                    <Link to={`/deleteuser/${user.Id}`}>
                      <i className="bi bi-trash3 text-danger"></i>
                    </Link>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      {/* Modal */}
      {selectedUser && (
        <div
          className="modal fade show"
          style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  User Details - {selectedUser.Name}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedUser(null)}
                ></button>
              </div>
              <div className="modal-body">
                <p>
                  <strong>First Name:</strong> {selectedUser.FirstName || "N/A"}
                </p>
                <p>
                  <strong>Last Name:</strong> {selectedUser.LastName || "N/A"}
                </p>
                <p>
                  <strong>Date of Birth:</strong>{" "}
                  {selectedUser.DateOfBirth || "N/A"}
                </p>
                <p>
                  <strong>Jersey Number:</strong>{" "}
                  {selectedUser.JerseyNumber || "N/A"}
                </p>
                <p>
                  <strong>Address:</strong> {selectedUser.Address || "N/A"}
                </p>
                <p>
                  <strong>School/Club:</strong> {selectedUser.SchoolClub || "N/A"}
                </p>
                <p>
                  <strong>Graduation Year:</strong>{" "}
                  {selectedUser.GraduationYear || "N/A"}
                </p>

                {selectedUser.Tier && selectedUser.DiscountCode && (
                  <div className="mt-3 p-2 border rounded" style={{ backgroundColor: "#f9f9f9" }}>
                    <p>
                      <strong>Tier:</strong> {selectedUser.Tier}
                    </p>
                    <p>
                      <strong>Discount Code:</strong> {selectedUser.DiscountCode.code}
                    </p>
                    <p>
                      <strong>Expiry Date:</strong>{" "}
                      {new Date(selectedUser.DiscountCode.expiresAt._seconds * 1000).toLocaleDateString()}
                    </p>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setSelectedUser(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
